import { InjectionToken } from '@angular/core';

/**
 * Configuration interface for TranslateHttpLoader
 */
export interface HttpLoaderConfig {
  /**
   * Path prefix for translation files
   * @default '../i18n/'
   */
  prefix: string;

  /**
   * File suffix for translation files
   * @default '.json'
   */
  suffix: string;

  /**
   * Additional translation resources loaded in order and deeply merged.
   * Later resources override earlier resources.
   */
  resources?: Array<{
    prefix: string;
    suffix: string;
  }>;
}

/**
 * Default configuration for TranslateHttpLoader
 */
export const DEFAULT_HTTP_LOADER_CONFIG: HttpLoaderConfig = {
  prefix: '../i18n/',
  suffix: '.json',
};

/**
 * Injection token for HttpLoader configuration
 */
export const HTTP_LOADER_CONFIG = new InjectionToken<HttpLoaderConfig>(
  'HTTP_LOADER_CONFIG',
  {
    providedIn: 'root',
    factory: () => DEFAULT_HTTP_LOADER_CONFIG,
  }
);
